const Component = () => import('./WhatDoYouBuy');

export { Component };
